import React, { useState } from 'react';
import Reveal from './Reveal';
import SubContent from './SubContent';
import UcommerceSlideShow from './UcommerceSlideShow';
import Scrollspy from 'react-scrollspy';
import './ProjectsContent.module.css';
import Modal from './Modal';
import UcommerceContent from './UcommerceContent';
import TrackerAppContent from './TrackerAppContent';
import CovidTrackerSlideShow from './CovidTrackerSlideShow';
import CovidTrackerContent from './CovidTrackerContent';
import FunProjectsContent from './FunProjectsContent';

const ProjectsContent = () => {
  const [selectedImg, setSelectedImg] = useState(null);
  return (
    <>
      <Modal image={selectedImg} setSelectedImg={setSelectedImg} />
      <Reveal>
        <SubContent value="uCommerce" />
      </Reveal>
      <UcommerceSlideShow setSelectedImg={setSelectedImg} />
      <UcommerceContent />
      <Reveal>
        <SubContent value="Tracker App" />
      </Reveal>
      <TrackerAppContent />
      <Reveal>
        <SubContent value="CovidTracker" />
      </Reveal>
      <CovidTrackerSlideShow setSelectedImg={setSelectedImg} />
      <CovidTrackerContent />
    </>
  );
};

export default ProjectsContent;
